var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiuxDesigningDelightcodeInfotech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 392,
    viewBox: "0 0 459 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92992 209.3C9.92992 209.3 11.7899 212.83 10.1399 216.14C8.48992 219.45 6.40992 222.77 7.64992 224.43C8.88992 226.09 12.6499 228.16 12.2099 231.68C11.7699 235.2 6.81992 242.25 9.92992 246.19C13.0399 250.13 18.2199 249.92 18.4299 254.27C18.6399 258.62 13.4299 262.14 14.8999 266.08C16.3699 270.02 24.8999 270.85 24.8999 273.54C24.8999 276.23 21.5799 279.14 24.2799 282.04C26.9799 284.94 39.9999 292.51 41.8199 289.4C43.6399 286.29 47.4399 277.69 44.9699 265.48C44.5499 263.43 41.6299 262.97 41.2199 260.07C40.8099 257.17 42.0499 251.99 39.9799 249.07C37.9099 246.15 31.2699 245.13 30.8599 242.85C30.4499 240.57 33.3399 234.98 30.4399 231.46C27.5399 227.94 20.6999 226.3 20.6999 224C20.6999 221.7 22.7799 218.82 19.8799 215.71C16.9799 212.6 9.92992 209.3 9.92992 209.3Z",
    fill: "#F14836"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8499 233.72C24.1699 246.72 31.7299 264.39 34.7999 272.92C38.5299 283.28 41.7999 290.78 43.4299 301.14C45.0599 311.5 45.9999 380.89 45.9999 380.89",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 210.55C11 210.55 14.52 213.45 17.63 226.09C17.83 226.9 18.06 227.76 18.31 228.67",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6998 232.91C74.2782 233.758 74.0455 234.686 74.0179 235.633C73.9902 236.579 74.1683 237.52 74.5398 238.39C75.8598 241.04 77.5398 243.69 76.5398 245.02C75.5398 246.35 72.5398 248.02 72.8898 250.82C73.2398 253.62 77.1998 259.28 74.7098 262.43C72.2198 265.58 68.0798 265.43 67.9098 268.9C67.7398 272.37 71.9098 275.2 70.7298 278.35C69.5498 281.5 62.7298 282.17 62.7298 284.35C62.7298 286.53 65.3898 288.83 63.2298 291.15C61.0698 293.47 50.6698 299.5 49.1798 297C47.6898 294.5 44.6898 287.63 46.6598 277.86C46.9898 276.22 49.3298 275.86 49.6598 273.53C49.9898 271.2 48.9998 267.06 50.6598 264.74C52.3198 262.42 57.6598 261.59 57.9498 259.74C58.2398 257.89 55.9498 253.44 58.2798 250.62C60.6098 247.8 66.0798 246.47 66.0798 244.62C66.0798 242.77 64.4198 240.47 66.7398 237.98C69.0598 235.49 74.6998 232.91 74.6998 232.91Z",
    fill: "#F14836"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7598 252.45C63.3098 262.88 57.2598 277 54.7598 283.82C51.7598 292.12 49.1798 298.12 47.8598 306.41C46.5398 314.7 45.8098 370.23 45.8098 370.23",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.87 233.91C73.87 233.91 71.05 236.23 68.57 246.35C68.41 247 68.22 247.69 68.02 248.41",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6798 279.87C18.0308 280.577 18.225 281.351 18.2492 282.14C18.2734 282.929 18.1269 283.713 17.8198 284.44C16.7098 286.66 15.3198 288.87 16.1498 289.98C16.9798 291.09 19.4798 292.48 19.1998 294.83C18.9198 297.18 15.5998 301.9 17.6798 304.53C19.7598 307.16 23.2198 307.02 23.3598 309.93C23.4998 312.84 19.9998 315.2 20.9998 317.83C21.9998 320.46 27.6498 321.02 27.6498 322.83C27.6498 324.64 25.4398 326.57 27.2398 328.51C29.0398 330.45 37.7498 335.51 38.9998 333.43C40.2498 331.35 42.7598 325.6 41.0998 317.43C40.8298 316.06 38.8798 315.75 38.5998 313.81C38.3198 311.87 39.1498 308.41 37.7698 306.47C36.3898 304.53 31.9498 303.84 31.6698 302.31C31.3898 300.78 33.3298 297.05 31.3898 294.69C29.4498 292.33 24.8798 291.23 24.8798 289.69C24.8798 288.15 26.2698 286.22 24.3298 284.14C22.3898 282.06 17.6798 279.87 17.6798 279.87Z",
    fill: "#F14836"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3098 296.2C27.1998 304.91 32.2498 316.7 34.3098 322.4C36.8098 329.33 38.9798 334.4 40.0798 341.27C41.1798 348.14 41.7998 373.91 41.7998 373.91",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3699 280.7C18.3699 280.7 20.7299 282.64 22.7999 291.09C22.9399 291.64 23.0899 292.21 23.2599 292.81",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9999 276.42C88.4946 277.027 88.1274 277.737 87.9236 278.5C87.7199 279.264 87.6845 280.062 87.8199 280.84C88.3899 283.25 89.2399 285.72 88.1699 286.61C87.0999 287.5 84.3699 288.28 84.0999 290.61C83.8299 292.94 85.9899 298.31 83.3599 300.4C80.7299 302.49 77.3599 301.55 76.5899 304.4C75.8199 307.25 78.5899 310.28 77.0799 312.62C75.5699 314.96 69.8799 314.2 69.4599 315.96C69.0399 317.72 70.7699 320.1 68.5699 321.58C66.3699 323.06 56.7699 326 55.9999 323.67C55.2299 321.34 54.1399 315.19 57.6099 307.62C58.1999 306.35 60.1699 306.5 60.8799 304.67C61.5899 302.84 61.5799 299.29 63.3699 297.72C65.1599 296.15 69.6399 296.48 70.2599 295.06C70.8799 293.64 69.8399 289.56 72.2599 287.71C74.6799 285.86 79.3899 285.83 79.7399 284.34C80.0899 282.85 79.1799 280.66 81.5499 279.08C83.9199 277.5 88.9999 276.42 88.9999 276.42Z",
    fill: "#F14836"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.85 290.79C74.05 298.61 66.43 308.94 63.13 314.02C59.13 320.19 54.3 324.14 53.19 331.07C52.08 338 51.48 363.71 51.48 363.71",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1799 277.07C88.1799 277.07 85.4399 278.42 81.4899 286.17C81.2299 286.67 80.9499 287.17 80.6399 287.74",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8298 388.7H55.2398C63.3498 384.52 69.1098 373.94 69.1098 361.53C69.2416 354.09 66.969 346.805 62.6298 340.76H32.4398C28.1149 346.81 25.8564 354.094 25.9998 361.53C25.9998 373.94 31.7198 384.52 39.8298 388.7Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5198 388.7H39.8298V391H55.5198V388.7Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M269.38 1H23.74V186.92H269.38V1Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M263.64 5.92993H29.47V182H263.64V5.92993Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.85 31.77C100.85 31.77 62.5899 29 59.3699 35C56.1499 41 58.4399 150.7 60.2899 152.08C62.1399 153.46 113.76 154.38 118.83 152.54C123.9 150.7 117 39.14 117 35.91C117 32.68 105 31.3 105 31.3",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3201 122.57C63.4001 137.03 63.7101 147.63 64.4401 147.92C66.7401 148.84 115.6 152.99 116.98 148.38C118.36 143.77 113.29 39.6001 113.29 39.6001",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.45 39.1399C111.45 39.1399 64.8999 37.2999 64.4499 39.5999C64.1499 41.0699 63.2999 84.2599 63.3099 115.66",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8201 47.4399H110.99",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.84 45.35C104.08 48.27 106.84 45.35 108.69 41.18C110.54 37.01 106.84 42.01 102.69 45.35C98.5401 48.69 100.85 46.19 102.23 41.6C103.61 37.01 100.85 41.6 97.1601 44.52C93.4701 47.44 95.3201 46.19 96.7001 41.18C98.0801 36.17 96.7001 41.18 91.1701 44.52C85.6401 47.86 88.4001 47.85 91.1701 42.85C93.9401 37.85 89.3301 42.85 84.2601 44.52C79.1901 46.19 84.2601 44.52 86.1001 39.93C87.9401 35.34 82.8701 41.18 79.1901 43.68C75.5101 46.18 79.1901 43.68 80.1101 40.76C81.0301 37.84 77.8001 41.6 74.1101 45.35C70.4201 49.1 74.1101 45.35 74.5701 42.01C75.0301 38.67 70.4201 47.44 70.4201 47.44C70.4201 47.44 71.8001 39.09 70.8801 41.18C70.2665 42.5198 69.4907 43.7793 68.5701 44.93",
    stroke: "#F14836",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7099 55.27H68.1199V78.78H90.7099V55.27Z",
    stroke: "#F14836",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7299 55.27L69.0499 59.42L76.8799 56.66L69.0499 64.03L81.9499 55.73L69.0499 69.56L86.5599 56.66L68.1199 73.71L90.2499 58.5L68.1199 78.78L90.2499 64.03L74.5799 77.86L90.7099 69.1L80.5699 77.4L90.2499 74.17L88.3999 77.4",
    stroke: "#F14836",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.18 127.18H92.9099V145.16H110.18V127.18Z",
    stroke: "#F14836",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4299 127.18L93.6099 130.35L99.5999 128.24L93.6099 133.88L103.48 127.53L93.6099 138.11L107 128.24L92.9099 141.28L109.82 129.65L92.9099 145.16L109.82 133.88L97.8399 144.45L110.18 137.75L102.42 144.1L109.82 141.63L108.41 144.1",
    stroke: "#F14836",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6599 87.54H111.91",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 91.6899L110.99 92.1499",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3201 56.6599H109.61",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3201 62.1899H109.61",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3201 67.72H109.61",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3201 73.25H109.61",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M110.99 94.45H68.1199V115.19H110.99V94.45Z",
    stroke: "#F14836",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67.66 98.6L73.65 94.91L66.74 105.51L78.26 94.91L68.12 110.13L86.1 94.45L70.43 112.89L89.79 94.91L75.04 112.89L96.24 94.45L79.19 114.73L100.39 94.91L84.26 113.81L105.92 94.45L89.33 114.73L110.99 94.45L95.32 114.27L110.07 101.37L100.39 113.35L110.07 106.9L108.17 109.98L106.38 112.89",
    stroke: "#F14836",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M118.83 41.91L150.47 38.02",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M111.76 73.49H144.94",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2099 106.44L46.9199 111.51",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M101.77 148.38C101.77 148.38 99.01 162.67 117.9 166.38",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M115.14 162.67L119.75 166.82L113.29 168.66",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M140.79 69.3401L148.17 73.9501L141.72 76.7201",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M144.48 36.6399L152.31 37.5599L146.78 42.6299",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7599 106.9L40.9299 113.35L50.6099 113.81",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M167.99 69.3401H150.47V87.7801H167.99V69.3401Z",
    fill: "#F14836"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M154.62 73.49L164.76 73.95",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.62 77.1799L164.76 77.6399",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M154.62 80.8701L164.76 81.3301",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.337 116.53L33.9377 118.583L36.0987 136.896L53.498 134.843L51.337 116.53Z",
    fill: "#F14836"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.52 122.22L48.65 121.49",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38.95 125.89L49.08 125.16",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3899 129.55L49.5099 128.82",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M141.866 154.896L124.444 153.043L122.494 171.38L139.916 173.232L141.866 154.896Z",
    fill: "#F14836"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M128.15 157.6L138.18 159.13",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M127.76 161.27L137.79 162.8",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M127.37 164.94L137.4 166.47",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M269.37 186.92H23.74V193.2H269.37V186.92Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M367.94 231.93V220.21H332.67V231.93C332.666 235.77 331.342 239.491 328.92 242.47L327.38 244.38H373.23L371.69 242.47C369.267 239.491 367.943 235.77 367.94 231.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M365.94 231.93V220.21H330.67V231.93C330.666 235.77 329.342 239.491 326.92 242.47L325.38 244.38H371.23L369.69 242.47C367.267 239.491 365.943 235.77 365.94 231.93Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M366.22 223.52H330.81V227.11H366.22V223.52Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M410.7 119.81H285.9C281.217 119.81 277.42 123.607 277.42 128.29V215.42C277.42 220.103 281.217 223.9 285.9 223.9H410.7C415.383 223.9 419.18 220.103 419.18 215.42V128.29C419.18 123.607 415.383 119.81 410.7 119.81Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M414.51 119.81H289.71C285.027 119.81 281.23 123.607 281.23 128.29V215.42C281.23 220.103 285.027 223.9 289.71 223.9H414.51C419.193 223.9 422.99 220.103 422.99 215.42V128.29C422.99 123.607 419.193 119.81 414.51 119.81Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M277.42 207.72H419.19V215.42C419.19 217.669 418.296 219.826 416.706 221.416C415.116 223.007 412.959 223.9 410.71 223.9H285.91C283.661 223.9 281.504 223.007 279.914 221.416C278.323 219.826 277.43 217.669 277.43 215.42V207.72H277.42Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M412.05 126.29H284.55V199.83H412.05V126.29Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M328.92 133.95H303.84C302.161 133.95 300.8 135.311 300.8 136.99V188.79C300.8 190.469 302.161 191.83 303.84 191.83H328.92C330.599 191.83 331.96 190.469 331.96 188.79V136.99C331.96 135.311 330.599 133.95 328.92 133.95Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M329.35 138.8H303.42V186.96H329.35V138.8Z",
    fill: "#F14836"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M363.53 139.61H340.06V142.04H363.53V139.61Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M351.4 144.88H340.47V156.21H351.4V144.88Z",
    fill: "#F14836"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M361.91 179.68H356.06V185.75H361.91V179.68Z",
    fill: "#F14836"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M363 164.3H340.74V175.63H363V164.3Z",
    fill: "#F14836"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M353.42 145.69H362.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M353.42 148.52H362.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M353.42 151.35H362.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M353.42 154.18H362.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M341.14 160.66H362.59",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M341.14 178.47H362.59",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M365.56 137.19H338.04V188.19H365.56V137.19Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M399.15 137.19H373.25V156.21H399.15V137.19Z",
    fill: "#BFBFBF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M399.15 137.19H373.25V141.24H399.15V137.19Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M382.03 144.18H375.26V150.73H382.03V144.18Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M395.57 144.18H388.8V150.73H395.57V144.18Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M396.66 139.49C396.66 139.688 396.601 139.881 396.491 140.046C396.381 140.21 396.225 140.338 396.043 140.414C395.86 140.49 395.659 140.509 395.465 140.471C395.271 140.432 395.093 140.337 394.953 140.197C394.813 140.057 394.718 139.879 394.679 139.685C394.641 139.491 394.66 139.29 394.736 139.107C394.812 138.925 394.94 138.768 395.104 138.659C395.269 138.549 395.462 138.49 395.66 138.49C395.925 138.49 396.179 138.595 396.367 138.783C396.555 138.97 396.66 139.225 396.66 139.49Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M390.98 140.47C391.521 140.47 391.96 140.031 391.96 139.49C391.96 138.949 391.521 138.51 390.98 138.51C390.439 138.51 390 138.949 390 139.49C390 140.031 390.439 140.47 390.98 140.47Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M397.08 166.52H377.25V181.09H397.08V166.52Z",
    fill: "#BFBFBF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M397.08 166.52H377.25V169.62H397.08V166.52Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M395.18 168.28C395.182 168.431 395.139 168.579 395.057 168.705C394.974 168.831 394.856 168.93 394.718 168.989C394.579 169.048 394.426 169.065 394.278 169.037C394.13 169.008 393.993 168.937 393.886 168.831C393.779 168.725 393.705 168.59 393.675 168.442C393.645 168.294 393.66 168.141 393.717 168.002C393.774 167.862 393.871 167.743 393.997 167.659C394.122 167.575 394.269 167.53 394.42 167.53C394.62 167.53 394.811 167.609 394.954 167.749C395.096 167.889 395.177 168.08 395.18 168.28Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M391.58 168.28C391.58 168.479 391.501 168.67 391.36 168.81C391.22 168.951 391.029 169.03 390.83 169.03C390.631 169.03 390.44 168.951 390.3 168.81C390.159 168.67 390.08 168.479 390.08 168.28C390.08 168.081 390.159 167.89 390.3 167.75C390.44 167.609 390.631 167.53 390.83 167.53C391.029 167.53 391.22 167.609 391.36 167.75C391.501 167.89 391.58 168.081 391.58 168.28Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M297.08 130.15H288.75V195.48H297.08V130.15Z",
    fill: "#BFBFBF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M297.08 130.15H288.75V133.15H297.08V130.15Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 135.15H290.75V139.82H294.75V135.15Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 142.81H290.75V147.48H294.75V142.81Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 150.48H290.75V155.15H294.75V150.48Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 158.15H290.75V162.82H294.75V158.15Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 165.81H290.75V170.48H294.75V165.81Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 173.48H290.75V178.15H294.75V173.48Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 181.15H290.75V185.82H294.75V181.15Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 188.81H290.75V193.48H294.75V188.81Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M408.42 129.48H302.42V132.15H408.42V129.48Z",
    fill: "#BFBFBF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M408.42 194.15H302.42V196.82H408.42V194.15Z",
    fill: "#BFBFBF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M371.24 244.38H325.38V246.47H371.24V244.38Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M401.22 242.67H294.75V246.47H401.22V242.67Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M199.34 391H195.01L192.84 258.33H201.51L199.34 391Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M199.34 391H197.43L197.69 258.33H201.51L199.34 391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M261.07 391H256.74L254.57 258.33H263.24L261.07 391Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M261.07 391H259.16L259.42 258.33H263.24L261.07 391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M238.97 391H234.63L232.47 258.33H241.13L238.97 391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M238.97 391H237.06L237.31 258.33H241.13L238.97 391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M280.68 391H276.34L274.18 258.33H282.84L280.68 391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M280.68 391H278.76L279.02 258.33H282.84L280.68 391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M265.16 260.36H197.18V343.36H265.16V260.36Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M402.46 391H398.13L395.96 258.33H404.63L402.46 391Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M442.09 391H437.75L435.59 258.33H444.25L442.09 391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M442.09 391H440.18L440.43 258.33H444.25L442.09 391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M446.99 253.33H187.13V262.46H446.99V253.33Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M446.99 253.33H187.13V257.89H446.99V253.33Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M446.99 253.33H408.63V262.46H446.99V253.33Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M455.39 246H180.08V255.13H455.39V246Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M455.39 246H417.03V255.13H455.39V246Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M261 268.33H201.5V297.33H261V268.33Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M237.75 279.83H224.75V284.33H237.75V279.83Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M261 304.83H201.5V333.83H261V304.83Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M237.75 316.33H224.75V320.83H237.75V316.33Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M352.59 313.47H370.37V277.71H352.59V313.47Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M357.04 350.29H365.93V300.77H357.04V350.29Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M365.1 346.48C365.1 346.48 372.57 354.96 391.77 357.91C401.91 359.47 412.47 361.41 421.63 366.26C427.52 369.38 439.25 376.21 439.25 384.01C439.259 385.156 438.987 386.286 438.457 387.302C437.928 388.318 437.157 389.188 436.212 389.836C435.268 390.485 434.179 390.892 433.041 391.021C431.902 391.15 430.75 390.998 429.684 390.578C428.618 390.158 427.672 389.483 426.928 388.612C426.183 387.741 425.665 386.701 425.416 385.582C425.168 384.464 425.198 383.302 425.504 382.198C425.81 381.094 426.382 380.081 427.17 379.25C422.374 372.035 414.937 366.99 406.46 365.2C391.86 362.02 381.2 363.32 360.66 349.66L365.1 346.48Z",
    fill: "#263238"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M358.75 346.48C358.75 346.48 351.28 354.96 332.08 357.91C321.94 359.47 311.38 361.41 302.22 366.26C296.32 369.38 284.6 376.21 284.6 384.01C284.589 385.157 284.86 386.288 285.389 387.306C285.918 388.323 286.689 389.195 287.634 389.844C288.579 390.494 289.669 390.902 290.808 391.031C291.947 391.161 293.101 391.009 294.168 390.588C295.234 390.167 296.181 389.491 296.926 388.619C297.67 387.746 298.188 386.704 298.435 385.585C298.682 384.465 298.65 383.302 298.343 382.197C298.035 381.093 297.46 380.081 296.67 379.25C301.469 372.037 308.904 366.993 317.38 365.2C331.99 362.02 342.65 363.32 363.19 349.66L358.75 346.48Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M358.45 391H365.16C365.524 391 365.82 390.705 365.82 390.34V378.54C365.82 378.176 365.524 377.88 365.16 377.88H358.45C358.085 377.88 357.79 378.176 357.79 378.54V390.34C357.79 390.705 358.085 391 358.45 391Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M359.9 391H363.71V347.67H359.9V391Z",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M404.54 174.46C402.32 186.298 400.983 198.284 400.54 210.32C400.25 219.6 400.1 227.55 399.96 234.56C399.54 256.35 399.3 268.43 395.87 271.68C395.43 271.98 392.59 273.73 386.65 274.23C384.99 274.37 379.71 274.44 372.53 274.48C349.76 274.41 325.83 274.22 325.45 274.22H324.06C324 274.22 323.95 274.33 323.9 274.38C310.22 274.3 306.7 274.22 306.45 274.22H305.06C302.19 276.71 303.9 279.91 306.4 279.93C308.27 279.93 340.86 280.22 363.15 280.22C367.09 280.22 370.8 280.22 374.09 280.22H389.15C400.82 280.22 410.49 280.14 413.15 279.92C421.4 279.24 425.1 276.45 425.49 276.13C430.99 271.25 431.2 260.54 431.71 234.68C431.84 227.68 432 219.74 432.28 210.5C432.729 198.413 434.1 186.378 436.38 174.5L404.54 174.46Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M227.75 361.17L230 372.92C230 372.92 228 377.17 220.25 380.67C212.5 384.17 208.75 385.67 208.75 386.67C208.75 387.67 208.25 389.92 210.25 390.67C212.25 391.42 254.75 390.67 254.75 390.67C254.75 390.67 257 389.67 257 384.92C257 380.17 255 371.42 255 369.42C255 367.42 253.59 362.6 253.59 361.92C253.59 361.24 236.5 362.17 236.5 362.17C236.5 362.17 231.5 357.42 227.75 361.17Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 362.17C236.5 362.17 237.75 373.42 238.5 374.17C239.25 374.92 255 374.92 255 374.92",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 362.17C236.5 362.17 237.75 373.42 238.5 374.17C239.25 374.92 255 374.92 255 374.92",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M255 369.42L237.5 369.67",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M208.75 388.67H256.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M259 220.25C259 220.25 245.14 266.91 243.44 273.34C241.74 279.77 251.56 336.23 251.56 337.24C251.56 338.25 252.91 341.3 252.91 344.68C252.91 348.06 251.56 349.07 252.24 350.09C252.92 351.11 255.24 353.47 254.94 355.5C254.836 357.065 254.117 358.524 252.94 359.56C252.194 360.339 251.266 360.919 250.24 361.25H242.12C242.12 361.25 240.12 346.03 234.68 305.8C229.24 265.57 238.07 242.57 239.76 235.13C240.911 230.33 242.612 225.679 244.83 221.27L259 220.25Z",
    fill: "#F14836",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M216.25 361.17L218.5 372.92C218.5 372.92 216.5 377.17 208.75 380.67C201 384.17 197.25 385.67 197.25 386.67C197.25 387.67 196.75 389.92 198.75 390.67C200.75 391.42 243.25 390.67 243.25 390.67C243.25 390.67 245.5 389.67 245.5 384.92C245.5 380.17 243.5 371.42 243.5 369.42C243.5 367.42 242.09 362.6 242.09 361.92C242.09 361.24 225 362.17 225 362.17C225 362.17 220 357.42 216.25 361.17Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M225 362.17C225 362.17 226.25 373.42 227 374.17C227.75 374.92 243.5 374.92 243.5 374.92",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M225 362.17C225 362.17 226.25 373.42 227 374.17C227.75 374.92 243.5 374.92 243.5 374.92",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 369.42L226 369.67",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M197.25 388.67H245",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M203.21 220.25C203.21 220.25 202.87 249.67 204.56 262.18C206.25 274.69 212.68 303.77 213.69 319.66C214.7 335.55 216.4 343 216.4 343C216.4 343 214 345 214 347C214 349 215.35 349 215 352.08C214.65 355.16 213.31 356.13 214.33 357.49C215.35 358.85 216.02 361.54 219.4 362.22C222.78 362.9 238.67 362.56 242.05 361.88C245.43 361.2 247.12 357.82 247.12 355.12C247.12 352.42 246.12 350.39 246.12 347.34C246.12 344.29 247.81 341.6 247.81 339.57C247.81 337.54 247.13 336.52 247.13 334.49C247.13 332.46 242.74 300.01 242.74 293.25C242.74 286.49 242.4 263.49 243.41 257.74C244.42 251.99 249.5 224.61 249.5 224.61L203.21 220.25Z",
    fill: "#F14836",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M224.64 230.17C228.655 231.547 232.841 232.365 237.08 232.6C240.336 232.691 243.583 232.995 246.8 233.51L248.62 225.01L224.64 230.17Z",
    fill: "#F14836",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M220.93 231.63C220.93 231.63 222.59 278.09 225.93 293.58C229.27 309.07 233.67 334.51 232.57 337.83C231.47 341.15 229.8 348.89 229.8 348.89C229.8 348.89 235.89 347.79 235.89 351.1C235.89 354.41 227.04 356.64 229.25 358.3C231.46 359.96 233.66 361.78 233.66 361.78",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M159.54 29.15L159.03 49.91L178.61 49.74L178.78 28.98L159.54 29.15Z",
    fill: "#F14836"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M181.82 67.4599C181.82 67.4599 177.6 63.2399 175.74 59.3599C173.88 55.4799 171.19 53.1199 171.19 50.4199C171.19 47.7199 172.37 41.4199 171.86 38.9399C171.35 36.4599 171.86 31.1799 173.55 31.1799C173.942 31.1799 174.33 31.2687 174.683 31.4397C175.036 31.6107 175.346 31.8595 175.59 32.1674C175.833 32.4752 176.004 32.8342 176.089 33.2174C176.173 33.6006 176.171 33.998 176.08 34.3799C175.74 36.0699 177.08 41.9799 177.08 41.9799C177.08 41.9799 178.43 30.6699 178.6 29.9799C178.77 29.2899 181.13 29.2999 182.15 29.8099C183.17 30.3199 184.34 30.1399 184.34 32.3399C184.34 34.5399 183.83 37.0599 183.83 37.5699C183.83 38.0799 188.56 40.7799 188.73 42.7999C188.9 44.8199 188.39 49.7199 187.21 51.7999C186.403 53.0582 185.732 54.3992 185.21 55.7999C185.04 56.4699 189.77 63.5599 189.77 63.5599L181.82 67.4599Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M189.69 60.3298L178.19 69.1198C178.19 69.1198 197.8 109.69 198.48 111C199.16 112.31 213.35 121.15 213.35 121.15L234.65 94.7698C234.65 94.7698 207.94 86.3198 207.27 85.3098C206.6 84.2998 189.69 60.3298 189.69 60.3298Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M203.25 209.42L202.25 225.17C202.25 225.17 215.25 230.67 229.25 230.42C243.25 230.17 262 224.67 262 224.67L264.75 209.17C264.75 209.17 231 211.92 220.75 210.92C210.5 209.92 203.25 209.42 203.25 209.42Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M193.25 204.42L192.5 208.92C192.5 208.92 203.09 214.7 226.5 216.92C240.907 218.248 255.435 216.719 269.25 212.42L269.5 204.67C257.051 207.638 244.298 209.148 231.5 209.17C218.626 208.837 205.815 207.246 193.25 204.42Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M212.25 111.42C212.25 111.42 204 125.92 201.25 137.17C198.5 148.42 193 200.42 192.25 203.42C191.5 206.42 209 212.42 220.5 212.67C232 212.92 257.75 213.42 262.25 211.67C266.75 209.92 271 207.42 271 204.67C271 201.92 271.25 191.67 271.25 183.42C271.25 175.17 268.75 131.67 266.5 121.67C264.25 111.67 262.75 104.67 262 103.42C261.25 102.17 255.75 96.1699 244.5 96.9199C235.719 97.5666 227.187 100.126 219.5 104.42C216.648 106.256 214.185 108.634 212.25 111.42Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 127.58C136.85 127.58 132.79 129.27 132.45 133.33C132.11 137.39 139.56 141.44 143.95 147.53C148.34 153.62 154.09 160 154.09 160L162.89 172.17L173.37 163.38L146.32 132C146.32 132 147.67 129 145.98 127.94C144.558 127.278 143.018 126.905 141.451 126.844C139.884 126.782 138.32 127.032 136.85 127.58Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M137.53 137.05L168 126.9C168 126.9 170 135.36 179.15 144.15C184.636 149.436 190.516 154.296 196.74 158.69L169.35 174.24L137.53 137.05Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M137.53 137.05C138.872 135.544 139.699 133.648 139.89 131.64C139.98 130.712 139.724 129.783 139.17 129.034C138.616 128.284 137.803 127.766 136.89 127.58L166.98 118.79C166.98 118.79 172.73 120.79 167.98 126.9L137.53 137.05Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M177.85 169.2C177.85 169.2 171.09 168.2 170.75 166.2C170.41 164.2 169.06 159.78 167.75 158.09C166.44 156.4 159.97 153.02 157.94 150.65C155.91 148.28 154.56 144.9 153.21 145.24C151.86 145.58 149.83 146.93 150.5 148.24C151.17 149.55 154.22 155.35 154.22 155.35L154.9 157.71C154.9 157.71 148.81 156.71 147.8 156.36C147.506 156.276 147.195 156.266 146.896 156.331C146.596 156.395 146.317 156.532 146.083 156.73C145.849 156.927 145.667 157.179 145.553 157.463C145.439 157.748 145.397 158.055 145.43 158.36C145.43 160.05 144.08 160.05 145.77 161.06C147.46 162.07 149.49 163.43 149.49 163.43C149.49 163.43 151.86 168.84 152.49 169.85C153.12 170.86 158.58 173.24 159.59 173.91C160.6 174.58 166.02 176.28 168.72 176.91C171.42 177.54 177.51 179.96 177.51 179.96L179.2 172.18L177.85 169.2Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M249.53 122.54C249.53 122.54 248.85 151.28 248.85 152.63C248.85 153.98 249.85 181.71 246.85 184.07C243.85 186.43 228.93 189.48 207.29 188.81C185.65 188.14 176.18 183.4 176.18 183.4L177.87 169.2L219.12 166.2C219.12 166.2 214.73 134.76 215.4 123.94C216.07 113.12 224.87 107.37 224.87 107.37",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M249.53 122.54C249.53 122.54 248.85 151.28 248.85 152.63C248.85 153.98 249.85 181.71 246.85 184.07C243.85 186.43 228.93 189.48 207.29 188.81C185.65 188.14 176.18 183.4 176.18 183.4L177.87 169.2L219.12 166.2C219.12 166.2 214.73 134.76 215.4 123.94C216.07 113.12 224.87 107.37 224.87 107.37",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M204 190.07C204 190.07 244.94 191.5 247.1 186.47C249.26 181.44 249.25 131.88 249.25 131.88",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M222 113.2C222 113.2 213.37 122.54 214.81 134.75C216.25 146.96 219.13 166.15 219.13 166.15L203.32 167.08",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M204.53 35.1199C204.53 35.1199 198.86 44.9299 199.95 46.2299C201.04 47.5299 200.17 49.9399 200.17 49.9399C200.17 49.9399 194.5 54.2999 194.94 55.8199C195.38 57.3399 199.94 61.4899 199.94 61.4899C199.94 61.4899 200.81 73.2599 201.94 74.3499C203.07 75.4399 210.44 76.7399 211.94 76.9599C212.768 77.0622 213.576 77.2845 214.34 77.6199L218.69 101.15L243.1 79.1499L239.18 68.6899C239.18 68.6899 237 54.6899 237.18 48.2099C237.36 41.7299 226.06 33.8199 219.31 31.8599C212.56 29.8999 204.53 35.1199 204.53 35.1199Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M209.1 21.8199C209.1 21.8199 203.44 15.9399 196.68 20.5199C189.92 25.0999 191.89 32.5199 197.99 35.1199C204.09 37.7199 211.28 35.7699 208.89 38.3899C206.5 41.0099 205.89 46.6699 209.54 47.7599C213.19 48.8499 212.59 52.9899 212.59 54.7599C212.59 56.5299 215.59 56.2899 216.3 54.7599C217.01 53.2299 218.69 49.0999 222.83 50.8399C226.97 52.5799 226.76 62.1699 225.23 64.5699C223.7 66.9699 222.18 66.7499 222.18 66.7499C222.18 66.7499 224.58 67.6199 223.05 70.4499L221.53 73.2899C221.53 73.2899 225.01 77.4299 233.73 75.8999C242.45 74.3699 244.41 70.4499 243.1 67.1899C241.79 63.9299 238.74 63.4799 242.01 58.6899C245.28 53.8999 253.35 48.2199 252.69 37.3299C252.26 30.1399 235.26 23.3299 235.26 23.3299C235.26 23.3299 239.18 16.7899 230.26 12.6499C221.34 8.50989 211.09 13.3099 211.74 17.6499C212.39 21.9899 209.1 21.8199 209.1 21.8199Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M199.89 45.4499C199.89 45.4499 197.12 44.7099 196.89 46.0199C196.66 47.3299 196.89 53.8599 196.89 53.8599C197.865 54.4663 199.026 54.7007 200.16 54.5199C201.69 54.0799 200.81 48.6299 200.81 48.6299",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M217.17 52.7699L197.1 49.4499L197.12 48.1899L217.17 52.7699Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M245.94 72.3898C245.94 72.3898 234.82 80.4498 227.19 88.7298C219.56 97.0098 210.41 106.17 210 109C209.59 111.83 210.43 116.19 214.79 111.61C219.15 107.03 227.21 100.94 233.32 100.5C239.43 100.06 248.79 103.12 253.58 103.77C258.37 104.42 261.43 105.77 263.17 103.12C264.91 100.47 260.34 94.6198 260.34 91.5598C260.34 88.4998 260.99 83.2798 258.81 79.5598C256.63 75.8398 249.64 71.2998 245.94 72.3898Z",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M260.18 83.1799C259.561 85.2977 258.716 87.3428 257.66 89.2799C256.39 91.1699 238.52 94.7499 238.52 94.7499C238.52 94.7499 253.24 93.9099 255.97 93.9099C258.7 93.9099 261.86 96.4299 261.86 96.4299L260.39 92.4299C260.39 92.4299 261 85.0799 260.18 83.1799Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1 391H458",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiuxDesigningDelightcodeInfotech);
export default __webpack_public_path__ + "static/media/uiux_designing_delightcode_infotech.0b9cc5f87f01c98869f094bfe2d915a4.svg";
export { ForwardRef as ReactComponent };